// Canonical flat product paths. The `/instagram/*` namespace was dead weight
// for a single-product SaaS — kept only as redirects for legacy links.
export const INSTAGRAM = "/instagram";
export const INSTAGRAM_AUTOMATIONS = "/automations";
export const INSTAGRAM_CONTACTS = "/leads";
export const INSTAGRAM_CREDITS = "/billing";

// Every historical path that should redirect to the new canonical slug.
// Extend this list when renaming routes — App.js renders one Navigate per entry.
export const LEGACY_REDIRECTS = [
  // Old first-time onboarding page — removed from flow
  { from: "/instagram_integration", to: "/" },
  // /automations is now merged into the home page
  { from: "/automations", to: "/" },
  // Namespace root
  { from: "/instagram", to: "/" },
  // Interim /instagram/<new-slug> from the previous rename pass
  { from: "/instagram/automations", to: "/" },
  { from: "/instagram/leads", to: INSTAGRAM_CONTACTS },
  { from: "/instagram/billing", to: INSTAGRAM_CREDITS },
  // Original DB-flavoured slugs
  { from: "/instagram/instagram_feature", to: "/" },
  { from: "/instagram/instagram_contacts", to: INSTAGRAM_CONTACTS },
  { from: "/instagram/instagram_credits", to: INSTAGRAM_CREDITS },
];

export const CUSTOMER_PROFILE = "/customer_profile";
export const INTEGRATION_ROUTE = "/integrations";
